import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout")({
    component: LogLayout,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.title"),
        };
    },
});

function LogLayout() {
    return <Outlet />;
}
